import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Alert, Col, Row } from '@syneto/compass-react';
import Form from '../../../../components/forms/form';

export const COMMUNITY_REPLACEMENT_NOTE = 'Saving removes "Community Support" and the Community licenses from this product. Every other license is kept. The paid maintenance starts on the date below.';

/*
 * Shown under the maintenance rows of a Community product once a paid maintenance is added (SYN-3454): what the save
 * removes, and the day the paid maintenance starts, today unless changed. `startDate` is the row's day at 00:00 UTC;
 * `onStartDateChange` gets the picked day as YYYY-MM-DD, or null when cleared.
 */
const CommunityReplacementNotice = ({ index, startDate, changeProp, onStartDateChange }) => {
	const fieldName = `maintenanceServices[${index}].startDate`;

	return (
		<Row className="community-replacement-notice mt-2">
			<Col xs={8}>
				<Alert appearance="warning">{COMMUNITY_REPLACEMENT_NOTE}</Alert>
			</Col>
			<Col xs={3}>
				<Form.datepicker
					label="Paid maintenance starts on"
					required
					id={fieldName}
					name={fieldName}
					placeholder="Today"
					autoComplete="off"
					initValue={startDate ? moment.utc(startDate).format('DD/MM/YYYY') : ''}
					changeProp={(value) => { changeProp(fieldName, value); }}
					onValueChange={onStartDateChange}
				/>
			</Col>
		</Row>
	);
};

CommunityReplacementNotice.propTypes = {
	index: PropTypes.number.isRequired,
	startDate: PropTypes.string,
	changeProp: PropTypes.func.isRequired,
	onStartDateChange: PropTypes.func.isRequired
};

export default CommunityReplacementNotice;
